import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { logout } from '@app/actions/session'

class LogoutLink extends Component {
  constructor(props) {
    super(props)
    this.handleLogout = this.handleLogout.bind(this)
  }

  handleLogout(_) { this.props.logout() }

  render() {
    const { children, logout, ...props } = this.props
    return (
      <a href="javascript:void(0)" onClick={this.handleLogout} {...props}>
        { children }
      </a>
    )
  }
}

const mapDispatchToProps = (dispatch) => {
  return { logout: bindActionCreators(logout, dispatch) }
}

export default connect(null, mapDispatchToProps)(LogoutLink)
